/* eslint-disable react/no-array-index-key */
import { ChangeEvent, Dispatch, FC, KeyboardEvent, SetStateAction, useEffect } from 'react';

import { CodeInputFieldStyled, CodeInputStyled, InputGroupStyled } from './CodeInput.styles';

interface Props {
	code: string[];
	updateCode: Dispatch<SetStateAction<string[]>>;
	splitBy?: number;
	onEnter: () => void;
}

export const CodeInput: FC<Props> = ({ code, updateCode, splitBy, onEnter }) => {
	useEffect(() => {
		const firstInput = document.querySelector(`#input-0`) as HTMLElement;
		firstInput.focus();
	}, []);

	const handleChange = (e: ChangeEvent<HTMLInputElement>, index: number): void => {
		if (e.target.nextSibling) {
			(e.target.nextSibling as HTMLElement).focus();
		}

		updateCode([...code.map((n, idx) => (idx === index ? e.target.value : n))]);
	};

	const handleBackspace = (e: KeyboardEvent<HTMLInputElement>, index: number): void => {
		if (e.key === `Backspace`) {
			e.preventDefault();
			updateCode(currCode => [...currCode.map((n, idx) => (idx === index ? `` : n))]);
			(e.target as EventTarget & HTMLInputElement).value = ``;
			((e.target as EventTarget & HTMLInputElement).previousSibling as HTMLElement).focus();
		} else if (e.key === `Enter` && index === 8) {
			onEnter();
		} else if (
			(e.target as EventTarget & HTMLInputElement).value !== `` &&
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
			((e.target as EventTarget & HTMLInputElement).nextSibling as HTMLElement)
		) {
			((e.target as EventTarget & HTMLInputElement).nextSibling as HTMLElement).focus();
		}
	};

	const determineIfSplit = (index: number): boolean => {
		if (!splitBy || (index + 1) % splitBy !== 0 || index === 0) {
			return false;
		}

		return index <= code.length - 1;
	};

	return (
		<CodeInputStyled>
			<InputGroupStyled>
				{code.map((char, index) => (
					<CodeInputFieldStyled
						id={`input-${index}`}
						maxLength={1}
						type='tel'
						onChange={e => handleChange(e, index)}
						// onFocus={e => e.target.select()}
						onKeyDown={e => handleBackspace(e, index)}
						value={char}
						key={`codeInput-${index}`}
						hasMargin={determineIfSplit(index)}
						onKeyPress={e => {
							if (e.charCode < 48 || e.charCode > 57) {
								e.preventDefault();
							}
						}}
					/>
				))}
			</InputGroupStyled>
		</CodeInputStyled>
	);
};
